import React, { useState, useEffect, useContext } from 'react';
import Modal from 'react-modal';
import axios from 'axios';
import { Toaster, toast } from 'react-hot-toast';
import '../App.css';
import { GrupoContext } from '../GrupoContext';
import Sidebar from '../componenteExtra/SidebarLider';
import SessionManager from '../componenteExtra/SessionManager';

Modal.setAppElement('#root');

const RevisarActividadLider = () => {
    const { grupo: liderGrupo, setGrupo } = useContext(GrupoContext);
    const [activities, setActivities] = useState([]);
    const [selectedActivity, setSelectedActivity] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [comentario, setComentario] = useState('');
    const [isRejection, setIsRejection] = useState(false);
    const [bitacoraRechazos, setBitacoraRechazos] = useState([]);
    const [isBitacoraModalOpen, setIsBitacoraModalOpen] = useState(false);

    // Selección masiva
    const [selectedActivities, setSelectedActivities] = useState([]);
    const [selectAll, setSelectAll] = useState(false);
    const [isBulkAcceptModalOpen, setIsBulkAcceptModalOpen] = useState(false);
    const [isBulkRejectModalOpen, setIsBulkRejectModalOpen] = useState(false);
    const [bulkComentario, setBulkComentario] = useState('');

    const token = localStorage.getItem("access_token");

    useEffect(() => {
        const savedGrupo = localStorage.getItem('grupo');
        if (savedGrupo) setGrupo(savedGrupo);
    }, [setGrupo]);

    useEffect(() => {
        if (liderGrupo) {
            localStorage.setItem('grupo', liderGrupo);
            axios.get(`${process.env.REACT_APP_BACKEND_URL}/my_assignments4/${liderGrupo}`, {
                headers: { Authorization: `Bearer ${token}` },
            })
                .then(res => setActivities(res.data))
                .catch(err => console.error('Error fetching data: ', err));
        }
    }, [liderGrupo]);

    // --- Selección ---
    const handleSelectAll = () => {
        setSelectAll(!selectAll);
        setSelectedActivities(selectAll ? [] : activities.map(a => a.id));
    };

    const handleSelectActivity = (id) => {
        setSelectedActivities(prev =>
            prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]
        );
    };

    useEffect(() => {
        setSelectAll(activities.length > 0 && selectedActivities.length === activities.length);
    }, [selectedActivities, activities]);

    // --- Aceptar masivo (modal) ---
    const handleOpenBulkAccept = () => {
        if (selectedActivities.length === 0) {
            toast.error('Selecciona al menos una actividad');
            return;
        }
        setIsBulkAcceptModalOpen(true);
    };

    const handleBulkAccept = () => {
        const toastId = toast.loading(`Aceptando ${selectedActivities.length} actividad${selectedActivities.length > 1 ? 'es' : ''}...`);

        const promises = selectedActivities.map(id => {
            const act = activities.find(a => a.id === id);
            return axios.put(`${process.env.REACT_APP_BACKEND_URL}/accept_activity`, {
                id: act.id,
                estados_staff: act.estados_staff + 1,
                rol: `Lider ${liderGrupo}`
            }, { headers: { Authorization: `Bearer ${token}` } });
        });

        Promise.all(promises)
            .then(() => {
                toast.dismiss(toastId);
                toast.success(`${selectedActivities.length} actividad${selectedActivities.length > 1 ? 'es' : ''} aceptada${selectedActivities.length > 1 ? 's' : ''}`);
                setActivities(prev => prev.filter(a => !selectedActivities.includes(a.id)));
                setSelectedActivities([]);
                setSelectAll(false);
                setIsBulkAcceptModalOpen(false);
            })
            .catch(err => {
                toast.dismiss(toastId);
                toast.error('Error al aceptar actividades');
                console.error(err);
            });
    };

    // --- Rechazar masivo (modal) ---
    const handleOpenBulkReject = () => {
        if (selectedActivities.length === 0) {
            toast.error('Selecciona al menos una actividad');
            return;
        }
        setIsBulkRejectModalOpen(true);
    };

    const handleBulkReject = () => {
        if (bulkComentario.length < 20) {
            toast.error('El comentario debe tener al menos 20 caracteres.');
            return;
        }

        const toastId = toast.loading(`Rechazando ${selectedActivities.length} actividad${selectedActivities.length > 1 ? 'es' : ''}...`);

        const promises = selectedActivities.map(id => {
            const act = activities.find(a => a.id === id);
            return axios.put(`${process.env.REACT_APP_BACKEND_URL}/reject_activity`, {
                id: act.id,
                estados_staff: act.estados_staff - 1,
                comentario_lider: bulkComentario,
                rol: `Lider ${liderGrupo}`
            }, { headers: { Authorization: `Bearer ${token}` } });
        });

        Promise.all(promises)
            .then(() => {
                toast.dismiss(toastId);
                toast.success(`${selectedActivities.length} actividad${selectedActivities.length > 1 ? 'es' : ''} rechazada${selectedActivities.length > 1 ? 's' : ''}`);
                setActivities(prev => prev.filter(a => !selectedActivities.includes(a.id)));
                setSelectedActivities([]);
                setSelectAll(false);
                setIsBulkRejectModalOpen(false);
                setBulkComentario('');
            })
            .catch(err => {
                toast.dismiss(toastId);
                toast.error('Error al rechazar actividades');
                console.error(err);
            });
    };

    // --- Revisión individual ---
    const handleReview = (activity) => {
        setSelectedActivity(activity);
        setIsModalOpen(true);
        setIsRejection(false);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
        setSelectedActivity(null);
        setComentario('');
        setIsRejection(false);
    };

    const handleAccept = () => {
        const toastId = toast.loading('Aceptando actividad...');
        axios.put(`${process.env.REACT_APP_BACKEND_URL}/accept_activity`, {
            id: selectedActivity.id,
            estados_staff: selectedActivity.estados_staff + 1,
            rol: `Lider ${liderGrupo}`
        }, { headers: { Authorization: `Bearer ${token}` } })
            .then(() => {
                toast.dismiss(toastId);
                toast.success('Actividad aceptada');
                handleCloseModal();
                setActivities(prev => prev.filter(a => a.id !== selectedActivity.id));
            })
            .catch(err => {
                toast.dismiss(toastId);
                toast.error('Error al aceptar');
                console.error(err);
            });
    };

    const handleReject = () => {
        if (comentario.length < 20) {
            toast.error('El comentario debe tener al menos 20 caracteres.');
            return;
        }
        const toastId = toast.loading('Rechazando actividad...');
        axios.put(`${process.env.REACT_APP_BACKEND_URL}/reject_activity`, {
            id: selectedActivity.id,
            estados_staff: selectedActivity.estados_staff - 1,
            comentario_lider: comentario,
            rol: `Lider ${liderGrupo}`
        }, { headers: { Authorization: `Bearer ${token}` } })
            .then(() => {
                toast.dismiss(toastId);
                toast.success('Actividad rechazada');
                handleCloseModal();
                setActivities(prev => prev.filter(a => a.id !== selectedActivity.id));
            })
            .catch(err => {
                toast.dismiss(toastId);
                toast.error('Error al rechazar');
                console.error(err);
            });
    };

    const handleShowRejection = () => setIsRejection(true);

    const handleShowBitacora = () => {
        const toastId = toast.loading('Cargando bitácora...');
        axios.get(`${process.env.REACT_APP_BACKEND_URL}/bitacora_rechazos/${selectedActivity.id}`, {
            headers: { Authorization: `Bearer ${token}` },
        })
            .then(res => {
                toast.dismiss(toastId);
                setBitacoraRechazos(res.data);
                setIsBitacoraModalOpen(true);
            })
            .catch(err => {
                toast.dismiss(toastId);
                if (err.response?.status === 404) {
                    toast.error('No hay registros');
                } else {
                    toast.error('Error al cargar bitácora');
                }
            });
    };

    const handleCloseBitacoraModal = () => setIsBitacoraModalOpen(false);

    const totalActividades = activities.length;

    return (
        <div className="app">
            <SessionManager />
            <Sidebar />
            <div className="main-content">
                <div className="main-panel">
                    <h1>Revisar Actividades del Grupo {liderGrupo}</h1>
                    <h2>Total Actividades: {totalActividades}</h2>

                    {/* Botones masivos */}
                    {selectedActivities.length > 0 && (
                        <div style={{ marginBottom: '15px', display: 'flex', gap: '10px' }}>
                            <button onClick={handleOpenBulkAccept} style={bulkAcceptBtn}>
                                Aceptar ({selectedActivities.length})
                            </button>
                            <button onClick={handleOpenBulkReject} style={bulkRejectBtn}>
                                Rechazar ({selectedActivities.length})
                            </button>
                        </div>
                    )}

                                <div className="activities-table-container">
                            <table className="activities-table">
                                <thead>
                                <tr>
                                    <th style={{ textAlign: 'center' }}>
                                    <div style={{ display: 'inline-flex', alignItems: 'center', gap: '10px' }}>
                                        <input
                                        type="checkbox"
                                        checked={selectedActivities.length === activities.length && activities.length > 0}
                                        onChange={handleSelectAll}
                                        style={{
                                            transform: 'scale(2.0)',
                                            cursor: 'pointer',
                                            verticalAlign: 'middle',
                                        }}
                                        />
                                        <span>Revisar</span>
                                    </div>
                                    </th>
                                    <th>Código de Proyecto</th>
                                    <th>Razón Social</th>
                                    <th>Filial</th>
                                    <th>Solicitante</th>
                                    <th>Tipo de trabajo</th>
                                    <th>Regulación</th>
                                    <th>Socio de auditoría</th>
                                    <th>Rubro GET</th>
                                    <th>Nombre Actividad GET</th>
                                    <th>Jefe de Grupo</th>
                                    <th>Subrogante</th>
                                    <th>Fecha de Entrega de Información</th>
                                    <th>Fecha Inicio</th>
                                    <th>Fecha Termino</th>
                                    <th>Horas GET</th>
                                    <th>Horas Estándar</th>
                                    <th>Acciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                {activities.map(activity => (
                                    <tr key={activity.id}>
                                        <td>
                                            <input
                                                type="checkbox"
                                                checked={selectedActivities.includes(activity.id)}
                                                onChange={() => handleSelectActivity(activity.id)}
                                                style={checkboxStyle}
                                            />
                                        </td>
                                        <td>{activity.codigo_proyecto}</td>
                                        <td>{activity.razon_social}</td>
                                        <td>{activity.filial}</td>
                                        <td>{activity.nombre_solicitante}</td>
                                        <td>{activity.tipo_solicitud}</td>
                                        <td>{activity.tipo_regulacion}</td>
                                        <td>{activity.encargado_auditoria}</td>
                                        <td>{activity.rubro_get}</td>
                                        <td>{activity.nombre_actividad_get}</td>
                                        <td>{activity.jefe_grupo}</td>
                                        <td>{activity.subrogante}</td>
                                        <td>{activity.fecha_entrega_informacion}</td>
                                        <td>{activity.fecha_de_inicio}</td>
                                        <td>{activity.fecha_de_termino}</td>
                                        <td>{activity.horas_get}</td>
                                        <td>{activity.horas_estandar}</td>
                                        <td>
                                            <button onClick={() => handleReview(activity)} style={reviewBtn}>
                                                Revisar
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            {/* Modal revisión individual */}
            {selectedActivity && (
                <Modal isOpen={isModalOpen} onRequestClose={handleCloseModal} style={compactModal}>
                    <h2 style={{ margin: '0 0 16px', fontSize: '18px' }}>Revisar Actividad</h2>
                    <div style={{ fontSize: '14px', lineHeight: '1.5' }}>
                        <p><strong>Staff:</strong> {selectedActivity.staff_asignado}</p>
                        <p><strong>Código:</strong> {selectedActivity.codigo_proyecto}</p>
                        <p><strong>Proyecto:</strong> {selectedActivity.nombre_proyecto}</p>
                        <p><strong>Razón Social:</strong> {selectedActivity.razon_social}</p>
                        <p><strong>Actividad:</strong> {selectedActivity.nombre_actividad_get}</p>
                        <p><strong>Enlace:</strong> <a href={selectedActivity.enlace_comentario} target="_blank" rel="noopener noreferrer" style={{ color: '#007bff' }}>Documentación</a></p>
                        <p><strong>Diferencias:</strong> {selectedActivity.diferencia}</p>
                        <p><strong>Comentario Solicitante:</strong> {selectedActivity.comentario_solicitante}</p>
                        <p><strong>Comentario SeniorGET:</strong> {selectedActivity.comentario_seniorGET}</p>
                    </div>

                    <div style={{ display: 'flex', gap: '8px', marginTop: '16px' }}>
                        <button onClick={handleAccept} style={acceptBtn}>Aceptar</button>
                        <button onClick={handleShowRejection} style={rejectBtn}>Rechazar</button>
                        <button onClick={handleShowBitacora} style={bitacoraBtn}>Bitácora</button>
                        <button onClick={handleCloseModal} style={baseBtn}>Cerrar</button>
                    </div>

                    {isRejection && (
                    <div style={{ marginTop: '16px' }}>
                        <textarea
                        value={comentario}
                        onChange={(e) => setComentario(e.target.value)}
                        placeholder="Comentario (mín. 20 caracteres)"
                        style={textareaStyle}
                        />
                        <button
                        onClick={() => {
                            if (comentario.length < 20) {
                            toast.error("El comentario debe tener al menos 20 caracteres para rechazar.");
                            return;
                            }
                            handleReject();
                        }}
                        style={{
                            ...rejectBtn,
                            opacity: comentario.length < 20 ? 0.6 : 1,
                            cursor: comentario.length < 20 ? 'not-allowed' : 'pointer'
                        }}
                        disabled={comentario.length < 20} // sigue deshabilitado
                        >
                        Enviar Rechazo
                        </button>
                        {/* Contador visual opcional (muy útil) */}
                        <div style={{ 
                        fontSize: '12px', 
                        color: comentario.length < 20 ? '#d32f2f' : '#4caf50', 
                        marginTop: '4px',
                        textAlign: 'right'
                        }}>
                        {comentario.length}/20 caracteres
                        </div>
                    </div>
                    )}
                </Modal>
            )}

            {/* Modal Aceptar Masivo */}
            <Modal isOpen={isBulkAcceptModalOpen} onRequestClose={() => setIsBulkAcceptModalOpen(false)} style={compactModal}>
                <h2 style={{ margin: '0 0 12px', fontSize: '18px' }}>Confirmar Aceptación</h2>
                <p style={{ margin: '0 0 16px', fontSize: '14px', color: '#555' }}>
                    ¿Aceptar <strong>{selectedActivities.length}</strong> actividad{selectedActivities.length > 1 ? 'es' : ''}?
                </p>
                <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
                    <button onClick={handleBulkAccept} style={acceptBtn}>Sí, Aceptar</button>
                    <button onClick={() => setIsBulkAcceptModalOpen(false)} style={cancelBtn}>Cancelar</button>
                </div>
            </Modal>

            {/* Modal Rechazar Masivo */}
            <Modal isOpen={isBulkRejectModalOpen} onRequestClose={() => setIsBulkRejectModalOpen(false)} style={compactModal}>
                <h2 style={{ margin: '0 0 12px', fontSize: '18px' }}>Rechazar {selectedActivities.length} actividad(es)</h2>
                <p style={{ margin: '0 0 12px', fontSize: '14px', color: '#555' }}>
                    Un mismo comentario se aplicará a todas:
                </p>
                <textarea
                value={bulkComentario}
                onChange={(e) => setBulkComentario(e.target.value)}
                placeholder="Motivo del rechazo masivo (mínimo 20 caracteres)"
                style={{
                    ...textareaStyle,
                    borderColor: bulkComentario.length > 0 && bulkComentario.length < 20 ? '#d32f2f' : '#ccc',
                    resize: 'vertical',
                    minHeight: '100px'
                }}
                />

                {/* Contador + estado visual */}
                <div style={{ 
                display: 'flex', 
                justifyContent: 'space-between', 
                alignItems: 'center', 
                marginTop: '8px',
                fontSize: '13px',
                fontWeight: '500'
                }}>
                <span style={{ 
                    color: bulkComentario.length < 20 ? '#d32f2f' : '#43a047' 
                }}>
                    {bulkComentario.length < 20 
                    ? `Faltan ${20 - bulkComentario.length} caracteres` 
                    : 'Listo'
                    }
                </span>
                <span style={{ color: '#666' }}>
                    {bulkComentario.length}/20
                </span>
                </div>

                <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end', marginTop: '12px' }}>
                <button 
                    onClick={() => {
                    if (bulkComentario.trim().length < 20) {
                        toast.error("El comentario debe tener al menos 20 caracteres para rechazar masivamente.", {
                        duration: 5000,
                        icon: 'Advertencia',
                        style: { fontSize: '14px' }
                        });
                        return;
                    }
                    handleBulkReject();
                    }} 
                    style={{
                    ...rejectBtn,
                    opacity: bulkComentario.trim().length < 20 ? 0.6 : 1,
                    cursor: bulkComentario.trim().length < 20 ? 'not-allowed' : 'pointer',
                    transition: 'all 0.2s ease'
                    }} 
                    disabled={bulkComentario.trim().length < 20}
                >
                    Rechazar Todas
                </button>
                
                <button 
                    onClick={() => { 
                    setIsBulkRejectModalOpen(false); 
                    setBulkComentario(''); 
                    }} 
                    style={cancelBtn}
                >
                    Cancelar
                </button>
                </div>
            </Modal>

            {/* Bitácora */}
            {isBitacoraModalOpen && (
                <Modal isOpen={isBitacoraModalOpen} onRequestClose={handleCloseBitacoraModal} style={compactModal}>
                    <h2 style={{ margin: '0 0 16px' }}>Bitácora</h2>
                    {bitacoraRechazos.length > 0 ? (
                        <div style={{ maxHeight: '300px', overflowY: 'auto', fontSize: '13px' }}>
                            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                <thead>
                                    <tr style={{ backgroundColor: '#f5f5f5' }}>
                                        <th style={thStyle}>Tipo</th>
                                        <th style={thStyle}>Fecha</th>
                                        <th style={thStyle}>Rol</th>
                                        <th style={thStyle}>Comentario</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {bitacoraRechazos.map((r, i) => (
                                        <tr key={i} style={{ borderBottom: '1px solid #eee' }}>
                                            <td style={tdStyle}>{r.tipo}</td>
                                            <td style={tdStyle}>{r.fecha}</td>
                                            <td style={tdStyle}>{r.rol}</td>
                                            <td style={tdStyle}>{r.comentario}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    ) : (
                        <p style={{ color: '#888' }}>No hay registros.</p>
                    )}
                    <div style={{ marginTop: '16px', textAlign: 'right' }}>
                        <button onClick={handleCloseBitacoraModal} style={cancelBtn}>Cerrar</button>
                    </div>
                </Modal>
            )}

            {/* Toaster arriba al centro */}
            <Toaster
                position="top-center"
                toastOptions={{
                    duration: 4000,
                    style: {
                        background: '#ffffffff',
                        color: '#000000ff',
                        padding: '12px 24px',
                        borderRadius: '8px',
                        fontSize: '15px',
                        boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
                        marginTop: '80px', // Espacio desde la parte superior
                    },
                    loading: {
                        iconTheme: { primary: '#fff', secondary: '#000' }
                    },
                    success: {
                        iconTheme: { primary: '#4CAF50' }
                    },
                    error: {
                        iconTheme: { primary: '#f44336' }
                    },
                }}
            />
        </div>
    );
};

// === ESTILOS MODERNOS Y COMPACTOS ===
const baseBtn = {
    padding: '9px 16px',
    border: 'none',
    borderRadius: '8px',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    fontSize: '14px',
    boxShadow: '0 2px 5px rgba(0,0,0,0.15)',
};

const acceptBtn = { ...baseBtn, backgroundColor: '#4CAF50', color: 'white' };
acceptBtn[':hover'] = { backgroundColor: '#45a049', transform: 'translateY(-1px)' };
acceptBtn[':active'] = { transform: 'translateY(1px)', boxShadow: '0 1px 2px rgba(0,0,0,0.2)' };

const rejectBtn = { ...baseBtn, backgroundColor: '#f44336', color: 'white' };
rejectBtn[':hover'] = { backgroundColor: '#d32f2f', transform: 'translateY(-1px)' };
rejectBtn[':active'] = { transform: 'translateY(1px)', boxShadow: '0 1px 2px rgba(0,0,0,0.2)' };

const bitacoraBtn = { ...baseBtn, backgroundColor: '#2196F3', color: 'white' };
bitacoraBtn[':hover'] = { backgroundColor: '#1976d2', transform: 'translateY(-1px)' };

const cancelBtn = { ...baseBtn, backgroundColor: '#999', color: 'white', padding: '9px 14px' };
cancelBtn[':hover'] = { backgroundColor: '#777' };
cancelBtn[':active'] = { transform: 'translateY(1px)' };

const bulkAcceptBtn = { ...acceptBtn, padding: '8px 14px', fontSize: '13px' };
const bulkRejectBtn = { ...rejectBtn, padding: '8px 14px', fontSize: '13px' };

const reviewBtn = { ...baseBtn, backgroundColor: '#8321a1ff', color: 'white', padding: '6px 12px', fontSize: '13px' };
reviewBtn[':hover'] = { backgroundColor: '#5f2785ff' };

const checkboxStyle = { cursor: 'pointer', transform: 'scale(2.0)' };

const textareaStyle = {
    width: '100%',
    padding: '10px',
    borderRadius: '6px',
    border: '1px solid #ccc',
    fontSize: '14px',
    marginBottom: '8px',
    resize: 'vertical',
};

const compactModal = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        width: '90%',
        maxWidth: '420px',
        padding: '20px',
        borderRadius: '12px',
        border: 'none',
        boxShadow: '0 10px 30px rgba(0,0,0,0.2)',
        background: '#fff',
    },
    overlay: { backgroundColor: 'rgba(0,0,0,0.6)', zIndex: 1000 }
};

const thStyle = { padding: '8px', textAlign: 'left', fontWeight: '600', fontSize: '13px' };
const tdStyle = { padding: '8px', fontSize: '13px' };

export default RevisarActividadLider;